module.exports = __webpack_public_path__ + "img/icon_zhichi_4@2x.61c63906.png";